import { useEffect } from "react";
import { sideEffectLogOut } from "../../../utils/common";

function ScreenAzureLogoutCallback() {
  useEffect(() => {
    sideEffectLogOut({ redirect: true });
  }, []);

  return <div>Signing you out...</div>;
}
export default ScreenAzureLogoutCallback;
